module.exports = __webpack_public_path__ + "img/26076-superbet-banner.fd3dc8ac.png";